import { useAuthStore } from '../stores/use-auth-store';
import { useHasCompleteAuthToken } from './use-has-complete-auth-token';

export function useIsAuthenticated() {
  const hasCompleteAuthToken = useHasCompleteAuthToken();
  const hasSuccessAuthStatus = useAuthStore(
    (state) => state.status === 'success'
  );
  const hasUser = useAuthStore((state) => !!state.user);
  return hasCompleteAuthToken && hasSuccessAuthStatus && hasUser;
}
